import { createSlice } from '@reduxjs/toolkit'
import { initialState } from './state'
import { reducers } from './reducers'

export const affiliateCenterSlice = createSlice({
  name: 'affiliateCenter',
  initialState,
  reducers
})
export const {
  setAffiliate
} = affiliateCenterSlice.actions
export default affiliateCenterSlice.reducer
